const doc = [({"da":({"js":({"admin":({"team_surveys":({"table":({"regions":"Regioner"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;